import { styled } from '@mui/system';
import { Grid2, Link, Typography, Box } from '@mui/material';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

export const GridStyled = styled(Grid2)({
  marginTop: '1.875rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '500px',
  minHeight: '117px',
  background: 'rgba(91, 194, 231, 0.5)',
  gap: '1.875rem',
  paddingBlock: '1.875rem'
});

export const LinkStyled = styled(Link)({
  textDecoration: 'none',
  border: '0.0625rem solid rgb(217, 217, 214)',
  borderRadius: '0.3125rem !important',
  padding: '0.625rem',
  margin: '0.3125rem',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  '&:hover': {
    cursor: 'pointer',
    border: '0.0625rem solid #007ACC'
  },
  alignItems: 'center'
});

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 450,
  color: theme.palette.primaryDark,
  fontFamily: 'BGBold',
  padding: '1.25rem'
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.875rem'
});

export const ToggleButtonGroupStyled = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    background: theme?.palette?.buttonFontColor,
    borderRadius: '0.9375rem',
    width: '100%',
    '& .MuiButtonBase-root.MuiToggleButtonGroup-grouped.Mui-selected': {
      border: `0.125rem solid ${theme?.palette?.lightBlue} !important`,
      backgroundColor: theme?.palette?.buttonFontColor
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0.3125rem !important'
    },
    '& .MuiToggleButtonGroup-lastButton, .MuiToggleButtonGroup-middleButton': {
      borderTop: '0.0625rem solid rgb(217, 217, 214) !important'
    },
    '& .MuiButtonBase-root.Mui-disabled': {
      background: '#D9D9D6 !important',
      p: {
        color: 'grey !important'
      },
      h2: {
        color: 'grey !important'
      }
    },
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3125rem'
  })
);

export const ToggleButtonStyled = styled(ToggleButton)(({ theme }) => ({
  background: theme.palette.common.white,
  width: '100%',
  height: 'auto',
  fontSize: '1rem',
  fontWeight: 450,
  color: theme?.palette?.primaryDark,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  border: '0.0625rem solid rgb(217, 217, 214)',
  borderRadius: '0.3125rem !important',
  padding: '0.625rem',
  margin: '0.3125rem'
}));
